import { render, staticRenderFns } from "./PersonDialog.vue?vue&type=template&id=3e530f82&scoped=true"
import script from "./PersonDialog.vue?vue&type=script&lang=js"
export * from "./PersonDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonDialog.vue?vue&type=style&index=0&id=3e530f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e530f82",
  null
  
)

export default component.exports